"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._validator = void 0;
const is_empty_1 = require("utils/is-empty");
const moment_1 = __importDefault(require("moment"));
const initialErrorStatus = {
    date_off: { status: false, message: 'Required' },
    event_day: { status: false, message: 'Required' },
};
const _validator = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    let validate = {
        isError: false,
        data: initialErrorStatus
    };
    const minDate = new Date(`01/01/${new Date().getFullYear()}`);
    const maxDate = new Date(`12/31/${new Date().getFullYear()}`);
    try {
        if (arg.date_off < minDate) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { date_off: {
                        status: true,
                        message: `Must be Higher than Minimum Date: ${(0, moment_1.default)(minDate).format('DD/MM/YYYY')}`
                    } })
            };
        }
        if (arg.date_off > maxDate) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { date_off: {
                        status: true,
                        message: `Must be Lower than Max Date: ${(0, moment_1.default)(maxDate).format('DD/MM/YYYY')}`
                    } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.event_day)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { event_day: { status: true, message: 'Required' } })
            };
        }
        return validate;
    }
    catch (error) {
        return {
            isError: false,
            data: initialErrorStatus
        };
    }
});
exports._validator = _validator;
